import createVideoElement from './createVideoElement';
import { VideoMeta } from './types';

async function getVideoMeta(src: string | File): Promise<VideoMeta | MediaError> {
  const videoElement = createVideoElement();

  if (typeof src === 'string') {
    videoElement.src = src;
  } else {
    videoElement.srcObject = src;
  }

  return new Promise((resolve) => {
    const onLoad = () => {
      const { duration, videoWidth, videoHeight } = videoElement;

      resolve({
        duration: duration,
        width: videoWidth,
        height: videoHeight,
      });

      videoElement.removeEventListener('loadedmetadata', onLoad);
    };

    const onError = () => {
      resolve(videoElement.error);
      videoElement.removeEventListener('error', onError);
    };

    videoElement.addEventListener('loadedmetadata', onLoad);
    videoElement.addEventListener('error', onError);
  });
}

export default getVideoMeta;
